import React from "react";
import locale from "antd/es/date-picker/locale/ru_RU";
import { DatePicker, Space } from "antd";
import "./index.scss";
import DefectRegister from "../../store/defectRegister";
import * as M from "moment";
import { observer } from "mobx-react-lite";
const { RangePicker } = DatePicker;
export const DatePickerComponent = observer(({ onChange }): React.FC => {
  const [picker, setPicker] = React.useState(true);

  const handlerOnChange = (e) => {
    M(e, "DD.MM.YYYY").set({
      h: 17,
      m: 17,
    });
    onChange(e);
    setPicker(true);
  };
  return (
    <div className="change_placeholder olddatepicker">
      {picker && <span className="start_date">Начальная дата</span>}
      {picker && <span className="end_date">Конечная дата</span>}
      <RangePicker
        className={"range-picker"}
        locale={locale}
        value={[
          DefectRegister.initialFilter?.dateFrom
            ? M(DefectRegister.initialFilter?.dateFrom, "DD.MM.YYYY").set({
                h: 17,
                m: 17,
              })
            : undefined,
          DefectRegister.initialFilter?.dateTo
            ? M(DefectRegister.initialFilter?.dateTo, "DD.MM.YYYY").set({
                h: 17,
                m: 17,
              })
            : undefined,
        ]}
        format="DD.MM.YYYY"
        onChange={handlerOnChange}
        onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
          const key = event.key;
          if (key === "Backspace" || key === "Delete") {
            return;
          }
          const input = event.target as HTMLInputElement;
          const curValue = input.value;

          if (curValue.length === 10) {
            event.preventDefault();
            return;
          }

          if (key < "0" || key > "9") {
            event.preventDefault();
            return;
          }

          let newValue = "";
          switch (curValue.length) {
            case 2:
            case 5:
              newValue = curValue + ".";
              break;
            default:
              newValue = curValue;
          }

          input.value = newValue;
        }}
      />
    </div>
  );
});
